import * as types from './mutation-types'

export const loadPrograms = ({ commit }, shopId = null) => {
  return new Promise((resolve, reject) => {
    const url = shopId ? `loyalty/programs?shop_id=${shopId}` : 'loyalty/programs'
    window.axios.get(url).then((response) => {
      commit(types.LOAD_PROGRAMS, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const loadMyShops = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/my-shops').then((response) => {
      commit(types.LOAD_MY_SHOPS, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const loadSimpleProducts = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/simple-products').then((response) => {
      commit(types.LOAD_SIMPLE_PRODUCTS, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const joinCustomer = ({ commit }, { phone, contactId }) => {
  return new Promise((resolve, reject) => {
    window.axios.post('loyalty/join', { phone, contact_id: contactId }).then(resolve).catch(reject)
  })
}

export const getMembershipByPhone = ({ commit }, phone) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/membership', { params: { phone } }).then((response) => {
      commit(types.SET_POS_MEMBERSHIP, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const clearPosMembership = ({ commit }) => {
  commit(types.CLEAR_POS_MEMBERSHIP)
}

export const getProgram = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/programs/' + id).then((response) => {
      commit(types.SET_CURRENT_PROGRAM, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const createProgram = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    window.axios.post('loyalty/programs', data).then((response) => {
      commit(types.ADD_PROGRAM, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const updateProgram = ({ commit }, { id, data }) => {
  return new Promise((resolve, reject) => {
    window.axios.patch('loyalty/programs/' + id, data).then((response) => {
      commit(types.UPDATE_PROGRAM, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const deleteProgram = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.delete('loyalty/programs/' + id).then((response) => {
      commit(types.REMOVE_PROGRAM, id)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const createReward = ({}, { programId, data }) => {
  return window.axios.post(`loyalty/programs/${programId}/rewards`, data)
}

export const updateReward = ({}, { programId, rewardId, data }) => {
  return window.axios.patch(`loyalty/programs/${programId}/rewards/${rewardId}`, data)
}

export const deleteReward = ({}, { programId, rewardId }) => {
  return window.axios.delete(`loyalty/programs/${programId}/rewards/${rewardId}`)
}

export const loadEarningTypes = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/earning-types').then((response) => {
      commit(types.LOAD_EARNING_TYPES, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const loadRewardTypes = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/reward-types').then((response) => {
      commit(types.LOAD_REWARD_TYPES, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const loadMembers = ({ commit }) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/members').then((response) => {
      commit(types.LOAD_MEMBERS, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}

export const getMember = ({ commit }, id) => {
  return new Promise((resolve, reject) => {
    window.axios.get('loyalty/members/' + id).then((response) => {
      commit(types.SET_CURRENT_MEMBER, response.data)
      resolve(response)
    }).catch((err) => reject(err))
  })
}
